import React, { lazy } from 'react';
import { MoonIcon, ActivityIcon, GaugeIcon, CloudRainIcon, SearchXIcon, BatteryLowIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const PAIN_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/9e26ace9-05f5-4e92-a345-e19bdd871928.jpg';
const painPoints = [{
  icon: MoonIcon,
  text: 'Te despiertas cansada aunque hayas dormido'
}, {
  icon: ActivityIcon,
  text: 'Te sientes inflamada sin razón aparente'
}, {
  icon: GaugeIcon,
  text: 'Tu metabolismo parece haberse detenido'
}, {
  icon: CloudRainIcon,
  text: 'Los cambios de humor controlan tu vida'
}, {
  icon: SearchXIcon,
  text: 'Sientes que probaste todo y nada funciona'
}, {
  icon: BatteryLowIcon,
  text: 'Tu energía desaparece antes del mediodía'
}];
export function PainSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-181" data-mp="22budd0vc9oq4">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-182" data-mp="2779p9n9sdajw">
        <Reveal className="order-2 lg:order-1" data-id="element-183" data-mp="3rlfybry0557q">
          <div className="overflow-hidden rounded-3xl shadow-xl shadow-tinta/10" data-id="element-184" data-mp="3nlpcm2nc1fa2">
            <img src={PAIN_IMG} alt="Mujer sentada al borde de la cama al despertar, con gesto de cansancio" className="h-full max-h-[560px] w-full object-cover" loading="lazy" data-id="element-185" data-mp="3nnryqbld6o9i" />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2" data-id="element-186" data-mp="38wsu1bnngjv7">
          <Reveal data-id="element-187" data-mp="33xydyhh2h9es">
            <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-188" data-mp="33yhmj7ktulg5">
              ¿Te identificas con esto?
            </h2>
          </Reveal>

          <ul className="mt-8 space-y-4" data-id="element-189" data-mp="3dvvyouzpwo2n">
            {painPoints.map((p, i) => <Reveal as="li" key={p.text} delay={i * 0.07} data-id="element-190" data-mp="2q61okl6s9dm3" data-mpi={i}>
                <div className="flex items-start gap-4 rounded-2xl bg-crema/70 p-4 sm:p-5" data-id="element-191" data-mp="2q4gvl004a2qc">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-rosa/15 text-rosa-dark" data-id="element-192" data-mp="2l6fdahaim7fx">
                    <p.icon className="h-5 w-5" strokeWidth={1.7} data-id="element-193" data-mp="p1ziv41sanfu" />
                  </span>
                  <span className="pt-2 text-base leading-snug text-tinta/85 sm:text-lg" data-id="element-194" data-mp="u0sk9y3sqnzn">
                    {p.text}
                  </span>
                </div>
              </Reveal>)}
          </ul>

          <Reveal delay={0.2} data-id="element-195" data-mp="64y08gfb4otf">
            <p className="mt-8 text-lg leading-relaxed text-tinta/70" data-id="element-196" data-mp="65py5xwdmymv">
              No estás sola, ni te estás inventando nada. Tu cuerpo te está
              hablando y merece que lo escuches.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}